import { jsx } from 'react/jsx-runtime';
import { getTzStartOfYear, getTzEndOfYear, getTzEachMonthOfInterval, setTimeToDay, formatDate } from '@ninja/utilities';
import { useWebUIConfigOptions } from './ThemeProvider2.js';
import styles from './DatePicker4.js';
import { checkIsValidRangeForMonthView } from './utils6.js';
import { useCalendarViewContext } from './components10.js';

const MonthsView = ({ onClick }) => {
    const { fromDate, toDate, enableTimeSelection, viewState: { tzDate, currentCalendar, intervalStartDate, intervalEndDate }, isIntervalPicker, maxSelectionRangeDays, } = useCalendarViewContext();
    const { isRtlLocale } = useWebUIConfigOptions();
    const startOfYear = getTzStartOfYear(tzDate, currentCalendar);
    const endOfYear = getTzEndOfYear(tzDate, currentCalendar);
    const months = getTzEachMonthOfInterval({
        tzDateStart: startOfYear,
        tzDateEnd: endOfYear,
        calendar: currentCalendar,
    });
    return (jsx("div", { className: styles.monthAndYearGrid, children: months.map((currentMonthDate, monthIndex) => {
            const disabled = !checkIsValidRangeForMonthView({
                isIntervalPicker,
                maxSelectionRangeDays,
                intervalStartDate,
                intervalEndDate,
                currentMonthDate,
                toDate,
                fromDate,
                currentCalendar,
            });
            return (jsx("div", { className: styles.monthAndYearItem(disabled), onClick: () => {
                    if (!disabled) {
                        const selectedDate = enableTimeSelection ? setTimeToDay(tzDate, currentMonthDate) : currentMonthDate;
                        onClick(selectedDate);
                    }
                }, children: formatDate(currentMonthDate, {
                    dateFormat: isRtlLocale ? 'MMMM' : 'MMM',
                    calendar: currentCalendar,
                }) }, monthIndex));
        }) }));
};

export { MonthsView };
